import axios from 'axios';
import Constants from '@/constants';

class ClientChatService {
    constructor() {
        this.table_name = 'realestate.client_logs'
    }

    async listAllByClient (client_code) {
        var query = `SELECT * FROM ${this.table_name} WHERE client_code='${client_code}' ORDER BY created_at DESC`
        console.log('query: ', query);

        query = encodeURI(query);
        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);

            return response.data;
        } 
        catch(err) {
            alert(err);
        }
    }
  
    async submitLogEntry(clientCode, created_by, description, type) {
        var columns = [
            'client_code', 
            'description', 
            'type',
            'created_by'];
        var values = [
            `'${clientCode}'`, 
            `'${description}'`,
            `'${type}'`,
            `'${created_by}'`
        ];

        var query = `INSERT INTO ${this.table_name} (`;
        query += columns.join(',');
        query += ') VALUES (';
        query += values.join(',');
        query += ');';

        query = encodeURI(query);

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);

            this.id = response.data.insertId;
        }
        catch (e) {
            alert(e);
        }
    }

    async updateLogEntry(id, description) {
        var query = `UPDATE ${this.table_name} SET description='${description}' WHERE id =${id}`;

        query = encodeURI(query);

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);
        }
        catch (e) {
            alert(e);
        }
    }

    async removeLogEntry(id) {
        var query = `DELETE FROM ${this.table_name} WHERE id =${id}`;

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);
        }
        catch (e) {
            alert(e);
        }
    }
  }
  
  
export default ClientChatService;